import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiPanelClose = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M12 11.5L16 7.5H8L12 11.5ZM19 3C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19ZM5 16V19H19V16H5ZM19 14V5H5V14H19Z"/>
  </SvgWrapper>
)
